// extracted by mini-css-extract-plugin
module.exports = {"link":"linkComponent_link__MC2NL","doublelinkcontainer":"linkComponent_doublelinkcontainer__YsQc1","hr":"linkComponent_hr__2UG0B"};